import React from "react";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import { NavLink } from "react-router-dom";
import NetworkChart from "../../assets/images/DataViz-RisksFirst-010.png";
import "./index.css";

export const Banner = () => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={3}>
      <Grid item size={{ xs: 12, sm: 6 }}>
        <div className="content-container">
          <div className="content-title">{t('title')}</div>
          <div className="content-description">
            {t('description')}
          </div>
          <NavLink className="focus-area" to="/focus-area">
            {t('focus-area')} <span className="arrow right"></span>
          </NavLink>
        </div>
      </Grid>
      <Grid item size={{ xs: 12, sm: 6 }} sx={{ p: 0, m: 0 }}>
        <div className="img-container">
          <img src={NetworkChart} alt="NetworkChart" className="NetworkChart" />
        </div>
      </Grid>
    </Grid>
  );
};
export default Banner;
